import { Upload } from "antd";

const CustomUpload = ({ children, showRemoveIcon = false, listType = "picture-card", ...props }) => {
  const dummyRequest = async ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  return (
    <Upload
      onPreview={(file) => {
        if (file.url) {
          return window.open(file.url);
        }
        window.open(URL.createObjectURL(file.originFileObj));
      }}
      listType={listType}
      rootClassName="upload-banner"
      showUploadList={{
        showRemoveIcon: showRemoveIcon,
      }}
      multiple={false}
      maxCount={1}
      customRequest={dummyRequest}
      {...props}
    >
      {children}
    </Upload>
  );
};

export default CustomUpload;
